"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/print/enums");
let AddBuildingBlockComponent = class AddBuildingBlockComponent {
    constructor() {
        this.blockSidesheet = false;
        this.addBuildingBlock = (blockType) => {
            switch (blockType) {
                case enums_1.EBuildingBlocks.TITLE:
                    this.array.push({
                        text: '',
                        type: enums_1.EBuildingBlocks.TITLE,
                    });
                    break;
                case enums_1.EBuildingBlocks.AUTHOR:
                    this.array.push({
                        text: '',
                        type: enums_1.EBuildingBlocks.AUTHOR,
                    });
                    break;
                case enums_1.EBuildingBlocks.TEXT:
                    this.array.push({
                        text: '',
                        customizable: false,
                        required: true,
                        type: enums_1.EBuildingBlocks.TEXT,
                    });
                    break;
                case enums_1.EBuildingBlocks.COLUMN:
                    this.array.push({
                        blocks: [],
                        type: enums_1.EBuildingBlocks.COLUMN,
                    });
                    break;
                case enums_1.EBuildingBlocks.CUSTOMER:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.CUSTOMER,
                    });
                    break;
                case enums_1.EBuildingBlocks.VEHICLE:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.VEHICLE,
                    });
                    break;
                case enums_1.EBuildingBlocks.OPTIONS:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.OPTIONS,
                        optionType: enums_1.EOptionTypes.SERIES,
                    });
                    break;
                case enums_1.EBuildingBlocks.VEHICLE_FIELD:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.VEHICLE_FIELD,
                    });
                    break;
                case enums_1.EBuildingBlocks.SIGNATURE:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.SIGNATURE,
                        name: '',
                    });
                    break;
                case enums_1.EBuildingBlocks.DEALER:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.DEALER,
                    });
                    break;
                case enums_1.EBuildingBlocks.SPACER:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.SPACER,
                    });
                    break;
                case enums_1.EBuildingBlocks.PAGE_BREAK:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.PAGE_BREAK,
                    });
                    break;
                case enums_1.EBuildingBlocks.INPUT:
                    this.array.push({
                        type: enums_1.EBuildingBlocks.INPUT,
                        inputType: enums_1.EInputTypes.TEXT,
                        name: '',
                        required: true,
                    });
                    break;
                default: break;
            }
            this.hideBlocksSidesheet();
        };
        this.hideBlocksSidesheet = () => {
            this.blockSidesheet = false;
        };
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], AddBuildingBlockComponent.prototype, "array", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], AddBuildingBlockComponent.prototype, "label", void 0);
AddBuildingBlockComponent = __decorate([
    (0, core_1.Component)({
        selector: 'add-block',
        templateUrl: require('./add-block.component.html'),
    })
], AddBuildingBlockComponent);
exports.default = AddBuildingBlockComponent;
